import type { ITabletopGroup, ITabletopUser } from '~/types/tabletop'

export function extractAllUserGroups(roles: ITabletopUser['roles']) {
  const allGroups = [] as ITabletopGroup[]
  if (Array.isArray(roles) && roles.length > 0) {
    roles.forEach((role) => {
      if (role?.organization?.groups) {
        allGroups.push(...role.organization.groups)
      }
    })
  }
  return allGroups
}

export function findAllUserLevels(groups: ITabletopGroup[]) {
  if (!Array.isArray(groups) || groups.length === 0) {
    return [] // Return empty array if groups is not an array or is empty
  }

  return groups
    .filter(
      (group) =>
        group &&
        typeof group.name === 'string' &&
        group.name.startsWith('WPN_LEVEL_'),
    )
    .map((group) => parseInt(group.name.split('_').pop() || ''))
    .sort((a, b) => b - a) // Sorting in descending order
}

export function findHighestUserLevel(groups: ITabletopGroup[]) {
  const allLevels = findAllUserLevels(groups)
  return allLevels.length > 0 ? allLevels[0] : 0 // Return the first level, which is the highest
}

// Example usage in another file:
// import { extractAllUserGroups, findAllUserLevels, findHighestUserLevel } from './parseUserLevel.js';

// const roles = ...; // Extracted 'roles' from your user JSON data, should be an array
// const userGroups = extractAllUserGroups(roles);
// console.log("Highest User Level:", findHighestUserLevel(userGroups));
// console.log("All User Levels:", findAllUserLevels(userGroups));
